<script src="https://code.iconify.design/1/1.0.7/iconify.min.js"></script>


<div class="pagecont">

    <div class="columnContainer">

        <!-- options -->
        <app-options></app-options>

        <!-- if room shown  -->
        <div *ngIf="this.DungeonPathService.showRoom === true">
            <div class="flexrow">
                <app-room-event></app-room-event>
            </div>
        </div>

        <!-- if dungeon path shown  -->
        <div *ngIf="this.DungeonPathService.showDungeonPath === true">
            <app-dungeon-path> </app-dungeon-path>
        </div>

         <!-- if title shown  -->
         <div *ngIf="this.PlayerInventoryService.isPlayerDead === true || 
         this.PlayerInventoryService.isPlayerWon === true ||
         this.DungeonPathService.showTitleScreen === true">
             <app-title></app-title>
        </div>

        <div></div>  

    </div>

    

</div>